import { render, staticRenderFns } from "./BodySlot.vue?vue&type=template&id=a7ca2416&scoped=true&lang=pug&"
import script from "./BodySlot.ts?vue&type=script&lang=ts&"
export * from "./BodySlot.ts?vue&type=script&lang=ts&"
import style0 from "./BodySlot.vue?vue&type=style&index=0&id=a7ca2416&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ca2416",
  null
  
)

export default component.exports